<app-aa-spinner [loading]="true"></app-aa-spinner>